import React, { useCallback, useEffect } from 'react'

import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';

import { getMixedProps } from './blockPublic'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

const AutoComplete = ({
	config: {
		field: {
			callback,		// 回调函数，参数为(text, 函数(用于回传新备选数据，参数内容为字符串数组))；如有此配置，以下配置无效
			event,
			params = {},		// 用于向后台取数据的event，以及发送到后台的参数(对象)，后台返回为:{data:[]}
			...field
		}, onChange, defaultStyle,
		that: { state: { _validStamp } },	// 用于验证的时间戳
	}
}) => {
	const { name } = field
	const { me, me: { state: { edited, data = [] } }, setState } = useInstData()

	const handleChange = useEventHandler(({ value }) => {
		!me.state.edited && setState({ edited: true })
		onChange({ name, newValue: value, type: 'string' })
	})

	let { props: { disabled, clearable, value, ...props } } = getMixedProps('_autoComplete', [defaultStyle, field])

	const lastParams = me.params = JSON.stringify(params) == JSON.stringify(me.params) ? me.params : params

	const getData = useCallback((text, cb) => {
		callback
			? callback(text, cb)
			: event && Tyan.doPostEvent(event, {
				data: { text, ...lastParams },
				onEnd: ({ errorMessage, data }) => {
					errorMessage && Ext.toast(errorMessage)
					cb(data || [])
				}
			})
	}, [lastParams])

	const handleFiltering = e => {
		const { text } = e

		const doFilter = data => e.updateData(data, null)
		getData(text, doFilter)
	}

	useEffect(() => {
		getData(value || '', data => setState({ data }))
	}, [value, lastParams])

	props.cssClass = !value && (edited || _validStamp)
		? props.cssClass ? `t-input-group ${props.cssClass} e-error` : 't-input-group e-error'
		: props.cssClass ? `t-input-group ${props.cssClass}` : 't-input-group'

	return <AutoCompleteComponent value={value}
		enabled={!disabled}
		showClearButton={clearable}
		change={handleChange}
		filtering={handleFiltering}
		{...props} /* {...labelContext} */
		ref={ref => ref && (me.acc = ref)}
		focus={() => me.acc && me.acc.showPopup()}
		dataSource={data}
	/>
}

const renderAutoComplete = config => {
	const { key } = config.field || {}
	return <AutoComplete key={key} config={config} />
}


export default renderAutoComplete